import React from "react";
import {Route} from "react-router-dom";
import Cookies from "js-cookie";
import {sessionStore} from "../../utils/sessionStore";

import RequireAuthentication from "hoc/authentication/requireAuthentication";

import ShippingMethods from "views/shippingMethods";

let routes = []
const token = sessionStore.get("token") ?? (Cookies.get("_f") ? JSON.parse(Cookies.get("_f").toString()) : null)

if (token) {
    routes.push([
        <Route
            path="/shipping_methods"
            component={RequireAuthentication(ShippingMethods)}
            key="shipping_methods"
            exact
        />,
    ])
}

export default routes
